<template>
    <section class="reportsection">
        <div class="container">
          <div class="row" v-for="rptdata in tworeportdata" :key="rptdata.invid">
            <div class="col-xs-12 col-sm-12 col-md-3 col1format">
              <div class="titleformat">{{ rptdata.invannrptheading}}</div>
              <div><a :href="`${myPicUrl}${rptdata.invrptlink}`"  class="linkcaption">{{rptdata.invannrptlinktext}}<i class="fa-solid fa-link"></i></a></div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col2format">
              <div>
                <div class="rptimg"><img :src="`${myPicUrl}${rptdata.invannrptimage}`"  class="leftimage" /></div>
                <div class="rptviewalltext"><router-link :to="{path: rptdata.invviewallrptlink}" class="linkcaption innerlink">{{ rptdata.invviewallfinrpttext}}</router-link></div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col3format">
                <div>
                    <div class="rptimg"><img :src="`${myPicUrl}${rptdata.invsustrptimage}`"  class="rightimage" /></div>
                    <div class="rptviewalltext"><router-link :to="{path: rptdata.invviewallsustlink}" class="linkcaption innerlink">{{ rptdata.invviewallsustrpttext}}</router-link></div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col4format">
                <div>
                    <div class="titleformat">{{ rptdata.invannsustrptheading}}</div>
                    <div class="rptviewalltext"><a :href="`${myPicUrl}${rptdata.invsustrptlink}`" class="linkcaption">{{rptdata.invannsustrptlinktext}} <i class="fa-solid fa-link"></i></a></div>
                </div>
            </div>
          </div>
        </div>
      </section>
</template>

<script>
  require('@/globalDeclare.js');
export default {
 props: ['tworeportdata'] ,
 data() {
    return {
       myPicUrl: '',
    }
 },
 mounted() {
    this.myPicUrl = myUrlPath
 } 
}
</script>

<style scoped>
.reportsection {
    background-color: whitesmoke;
    padding: 100px;
}
.col1format {
 text-align: right;
}
.linkcaption {
    text-decoration: none;
    color: rgb(9, 92, 139);
    font-size: 18px;
    font-weight: bold;
  }
.fa-link {
    color: orangered;
}
.rptviewalltext {
    padding-top: 20px;
    color: orange;
}
.innerlink {
    color: rgb(122, 83, 10);
}
.leftimage {
  width: 100%;
  padding: 20px;
}
.rightimage {
  width: 100%;
  padding: 20px;
}
@media only screen and (max-width: 600px) {
.reportsection {
  padding: 10px;
  padding-top: 100px;
  padding-bottom: 100px;
}
.col1format, .rptviewalltext, .linkcaption, .titleformat, .innerlink{
  text-align: center;
 }
 .col4format {
  padding-bottom: 100px;
 }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .reportsection {
    padding: 10px;
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .col1format, .rptviewalltext, .linkcaption, .titleformat, .innerlink{
    text-align: center;
   }
   .col4format {
    padding-bottom: 100px;
   }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {

}


/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .leftimage {
    width: 100%;
  }
  .rightimage {
    width: 100%;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {
    .col1format {
      margin-top: 130px;
    }
    .titleformat {
     font-weight: bold;
     font-size: 24px;
     color: #003;
    }
    .linkcaption {
      text-decoration: none;
    }


    .col4format {
        margin-top: 130px;
    }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1600px) {

  }
   
</style>